module.exports = __webpack_public_path__ + "img/ghost.5b156aa9.svg";